import KnockFail from './knock-fail.wav';
import KnockSuccess from './knock-success.wav';
import Knock from './knock.wav';
import Scorpion1 from './scorpion1.mp3';
import Scorpion2 from './scorpion2.mp3';
import Slap from './slap.wav';
import Stopwatch from './stopwatch.mp3';

const cdn = (name: string) => `https://s.metroretro.io/app/sounds/${name}`;

export const Sounds = {
    Knock,
    KnockFail,
    KnockSuccess,
    Scorpion1,
    Scorpion2,
    Slap,
    Stopwatch,
    Buzzer1: cdn('Buzzer1.webm'),
    Buzzer2: cdn('Buzzer2.webm'),
    Buzzer3: cdn('Buzzer3.webm'),
    Buzzer4: cdn('Buzzer4.webm'),
    Buzzer5: cdn('Buzzer5.webm'),
    Chicken: cdn('Chicken.webm'),
    Countdown: cdn('Countdown.webm'),
    Cow: cdn('Cow.webm'),
    Crash: cdn('Crash.webm'),
    Fanfare: cdn('Fanfare.webm'),
    Glass: cdn('Glass.webm'),
    Inception: cdn('Inception.webm'),
    TVStinger: cdn('TVStinger.webm'),
    Throw: cdn('Throw.webm'),
};

// export type Track = {
//     id: string,
//     name: string,
//     path: any,
//     length: number,
// };

// // Store track length as milliseconds, 1000 = 1 second
// const Tracks: Track[] = [
//     {
//         id: 'guzheng_city',
//         name: 'Guzheng City',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Guzheng%20City.mp3',
//         length: 120000,
//     },
//     {
//         id: 'airport_lounge',
//         name: 'Airport Lounge',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Airport%20Lounge.mp3',
//         length: 308000,
//     },
//     {
//         id: 'covert_affair',
//         name: 'Covert Affair',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Covert%20Affair.mp3',
//         length: 194000,
//     },
//     {
//         id: 'beach_party',
//         name: 'Beach Party',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Beach%20Party.mp3',
//         length: 50000,
//     },
//     {
//         id: 'as_i_figure',
//         name: 'As I Figure',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/As%20I%20Figure.mp3',
//         length: 216000,
//     },
//     {
//         id: 'windswept',
//         name: 'Windswept',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Windswept.mp3',
//         length: 188000,
//     },
//     {
//         id: 'loopster',
//         name: 'Loopster',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Loopster.mp3',
//         length: 182000,
//     },
//     {
//         id: 'space_jazz',
//         name: 'Space Jazz',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Space%20Jazz.mp3',
//         length: 370000,
//     },
//     {
//         id: 'vibing_over_venus',
//         name: 'Vibing Over Venus',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Vibing%20Over%20Venus.mp3',
//         length: 411000,
//     },
//     {
//         id: 'galactic_rap',
//         name: 'Galactic Rap',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Galactic%20Rap.mp3',
//         length: 142000,
//     },
//     {
//         id: 'jellyfish_in_space',
//         name: 'Jellyfish in Space',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Jellyfish%20in%20Space.mp3',
//         length: 391000,
//     },
//     {
//         id: 'space_1990',
//         name: 'Space 1990',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Space%201990.mp3',
//         length: 266000,
//     },
//     {
//         id: 'bleeping_demo',
//         name: 'Bleeping Demo',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Bleeping%20Demo.mp3',
//         length: 214000,
//     },
//     {
//         id: 'equatorial_complex',
//         name: 'Equatorial Complex',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Equatorial%20Complex.mp3',
//         length: 180000,
//     },
//     {
//         id: 'onion_capers',
//         name: 'Onion Capers',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Onion%20Capers.mp3',
//         length: 135000,
//     },
//     {
//         id: 'maple_leaf_rag',
//         name: 'Maple Leaf Rag',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Maple%20Leaf%20Rag.mp3',
//         length: 179000,
//     },
//     {
//         id: 'frogs_legs_rag',
//         name: 'Frogs Legs Rag',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Frogs%20Legs%20Rag.mp3',
//         length: 170000,
//     },
//     {
//         id: 'fuzzball_parade',
//         name: 'Fuzzball Parade',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Fuzzball%20Parade.mp3',
//         length: 314000,
//     },
//     {
//         id: 'hillbilly_swing',
//         name: 'Hillbilly Swing',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Hillbilly%20Swing.mp3',
//         length: 167000,
//     },
//     {
//         id: 'corncob',
//         name: 'Corncob',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Corncob.mp3',
//         length: 53000,
//     },
//     {
//         id: 'fig_leaf_rag',
//         name: 'Fig Leaf Rag',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Fig%20Leaf%20Rag.mp3',
//         length: 209000,
//     },
//     {
//         id: 'wholesome',
//         name: 'Wholesome',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Wholesome.mp3',
//         length: 364000,
//     },
//     {
//         id: 'stringed_disco',
//         name: 'Stringed Disco',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Stringed%20Disco.mp3',
//         length: 174000,
//     },
//     {
//         id: 'lord_of_the_rangs',
//         name: 'Lord of the Rangs',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Lord%20of%20the%20Rangs.mp3',
//         length: 154000,
//     },
//     {
//         id: 'cloud_dancer',
//         name: 'Cloud Dancer',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Cloud%20Dancer.mp3',
//         length: 240000,
//     },
//     {
//         id: 'brain_dance',
//         name: 'Brain Dance',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Brain%20Dance.mp3',
//         length: 215000,
//     },
//     {
//         id: 'club_seamus',
//         name: 'Club Seamus',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Club%20Seamus.mp3',
//         length: 146000,
//     },
//     {
//         id: 'island_meet_and_greet',
//         name: 'Island Meet and Greet',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Island%20Meet%20and%20Greet.mp3',
//         length: 216000,
//     },
//     {
//         id: 'dragon_and_toast',
//         name: 'Dragon and Toast',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Dragon%20and%20Toast.mp3',
//         length: 352000,
//     },
//     {
//         id: 'klockworx',
//         name: 'Klockworx',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Klockworx.mp3',
//         length: 242000,
//     },
//     {
//         id: 'southern_gothic',
//         name: 'Southern Gothic',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Southern%20Gothic.mp3',
//         length: 147000,
//     },
//     {
//         id: 'adding_the_sun',
//         name: 'Adding the Sun',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Adding%20the%20Sun.mp3',
//         length: 176000,
//     },
//     {
//         id: 'wind_of_the_rainforest',
//         name: 'Wind of the Rainforest',
//         path: 'https://incompetech.com/music/royalty-free/mp3-royaltyfree/Wind%20of%20the%20Rainforest.mp3',
//         length: 3534000,
//     },
// ];

// const track = (id: string) => Tracks.find(x => x.id === id);

// export const Playlists = {
//     'chill': {
//         label: 'Chill',
//         tracks: [
//             track('guzheng_city'),
//             track('airport_lounge'),
//             track('covert_affair'),
//             track('beach_party'),
//             track('as_i_figure'),
//             track('windswept'),
//             track('loopster'),
//         ],
//     },
//     'space': {
//         label: 'Space',
//         tracks: [
//             track('space_jazz'),
//             track('vibing_over_venus'),
//             track('galactic_rap'),
//             track('jellyfish_in_space'),
//             track('space_1990'),
//             track('bleeping_demo'),
//             track('equatorial_complex'),
//         ],
//     },
//     'playful': {
//         label: 'Playful',
//         tracks: [
//             track('onion_capers'),
//             track('maple_leaf_rag'),
//             track('frogs_legs_rag'),
//             track('fuzzball_parade'),
//             track('hillbilly_swing'),
//             track('corncob'),
//             track('fig_leaf_rag'),
//             track('wholesome'),
//         ],
//     },
//     'groove': {
//         label: 'Groove',
//         tracks: [
//             track('stringed_disco'),
//             track('lord_of_the_rangs'),
//             track('cloud_dancer'),
//             track('brain_dance'),
//             track('club_seamus'),
//             track('island_meet_and_greet'),
//         ],
//     },
//     'dramatic': {
//         label: 'Dramatic',
//         tracks: [
//             track('dragon_and_toast'),
//             track('klockworx'),
//             track('southern_gothic'),
//             track('adding_the_sun'),
//         ],
//     },
//     'ambient': {
//         label: 'Ambient',
//         tracks: [
//             track('wind_of_the_rainforest'),
//         ],
//     },
// };
